import * as React from 'react';
import { Button } from 'semantic-ui-react';

interface PatientLedgerEditColumnsButtonProps {
    onEditColumnsButtonHandler: () => void;
}

class PatientLedgerEditColumnsButtonComponent extends React.Component<PatientLedgerEditColumnsButtonProps, any> {
    render() {
        return (
            <Button
                id='id_btn_edit_columns_ledger_entry'
                type='button'
                onClick={this.props.onEditColumnsButtonHandler}
                content="Edit Columns"
                className="patient-ledger-edit-columns-btn"
            />
        );
    }
}

export default PatientLedgerEditColumnsButtonComponent;
